import firebase from 'firebase'
import { 
  createContentNote,
  updateContentNote,
  getContentNoteList
} from '@/service/influencer/contentNote'

const state = {
  contentNotes: []
}

const getters = {
  contentNotesStore: state => state.contentNotes,
}

const actions = {
  async createContentNote({dispatch}, {contentId, text}) {
    const data = {
      contentId: contentId,
      text: text,
      usertoken: firebase.auth().currentUser.uid
    }
    const response = await createContentNote(data)
    if (response.data.success) {
      dispatch('getContentNoteList', contentId)
    }
  },
  async updateContentNote({dispatch}, {contentId, noteId, text, status}) {
    const data = {
      noteId: noteId,
      text: text,
      status: status,
      usertoken: firebase.auth().currentUser.uid
    }
    const response = await updateContentNote(data)
    if (response.data.success) {
      dispatch('getContentNoteList', contentId)
    }
  },
  async getContentNoteList({commit}, contentId) {
    const response = await getContentNoteList(contentId)
    commit('setContentNotes', response.data.result)
  }
}

const mutations = {
  setContentNotes(state, contentNotes) {
    state.contentNotes = contentNotes
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}